// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".briq-button[data-v-21043e8a] {\n  margin-left: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
